import type { ProductForCustomer } from "../Product.js";

export function doesProductForCustomerHaveMultipleSizes(product: Pick<ProductForCustomer, "basicPrice">): boolean {
	return Object.values(product.basicPrice).filter(Boolean).length > 1;
}
